export const DELIVERY_CALCULATION_STRATEGIES = {
	DEFAULT: 'default',
	SIMPLE: 'simple',
} as const;

export const DELIVERY_CALCULATION_MODE = {
	ISSUE_COUNT: 'issue_count',
	STORY_POINTS: 'story_points',
} as const;
